import React, { useMemo } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { SafeComponent } from '@fiverr-private/orca';
import ServiceItem from '../ServiceItem';
import { getDefaultPopularServices } from './config';

const PopularServices = () => {
    const popularServices = useMemo(() => getDefaultPopularServices(), []);

    return (
        <Container width="100%" maxWidth="100%">
            <Stack
                direction="row"
                gap="4"
                wrap={{ default: 'nowrap', sm: 'wrap' }}
                overflow="auto"
                justifyContent="flexStart"
                width="100%"
            >
                {popularServices.map(({ elementName, labelKey, href, eventName, isNew, onClick }, index) => (
                    <ServiceItem
                        key={elementName}
                        elementName={elementName}
                        labelKey={labelKey}
                        href={href}
                        eventName={eventName}
                        index={index}
                        isNew={isNew}
                        onClick={onClick}
                    />
                ))}
            </Stack>
        </Container>
    );
};

export default SafeComponent(PopularServices);
